
import PIXI from '../GameEngine/pixi.js';
//import { Easing, Tween, autoPlay } from '../GameEngine/es6-tween.js'
import TWEEN from '../GameEngine/Tween.js';
export default class PopUpMessage extends PIXI.Sprite {
    constructor(text, ...arg) {
        super(...arg);
        let style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 70,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            strokeThickness: 5,
            align: 'center',
            dropShadow: true,
            dropShadowColor: '#000000',
            xdropShadowBlur: 5,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 8,
        });

        text = text || '';
        this.messageQueue = [];
        //create text 
        //hack: scale text to 1/2 the size and incress the font 2x to force better res when streching to a larger screen.  
        //hack: pixelDensity solves this partly, but when the container is scaled it does not know such as desktop with pixelDensity of 1.
        this.textMessage = new PIXI.Text('', style);
        this.textMessage.x = 0;
        this.textMessage.y = 0;
        this.textMessage.scale.set(0.5);
        this.textMessage.anchor.set(0.5, 0);
        //this.textMessage.resolution = 2;//does not seem to do anything
        this.addChild(this.textMessage);

        this.hide();
        //this.show("Test Test Test Test Test Test");


        this.tweenGroup = new TWEEN.Group();

        this.tween = new TWEEN.Tween(this.textMessage, this.tweenGroup);
        this.tween.to({ y: -40 }, 3000);
        this.tween.easing(TWEEN.Easing.Exponential.Out);
        this.tween.onStart(this.onStart.bind(this));
        this.tween.onComplete(this.onComplete.bind(this));
        this.tween.onStop(this.onStop.bind(this));
        //.start();
    }
    update(instantMove) {
        let isDirty = false;


        let isPlaying = this.tween.isPlaying();
        if (isPlaying) {
            let updated = this.tweenGroup.update();
            isDirty = true;
        }

        return isDirty;

    }
    onStart() {
        this.visible = true;
    }
    onComplete() {
        this.visible = false;
    }
    onStop() {
        this.visible = false;

    }
    show2(text) {
        this.messageQueue.push(text);
        this.showNext();
    }
    showNext2() {
        let isPlaying = this.visible;
        if (isPlaying) return;

        if (this.messageQueue.length !== 0) {
            let message = this.messageQueue.shift();
            this.showMessage(message);
        }
    }
    show(text) {

        if (text) this.textMessage.text = text;
        // //if (text) this.textMessageShadow.text = text;

        // this.textMessage.targetX = 0;  
        // this.textMessage.targetY = -50;  
        // //this.alpha = 0.5;
        // this.visible = true;
        // //  var timer = setTimeout(this.hide.bind(this),1000);

        //reset pos 
        this.visible = true;
        this.textMessage.x = 0;
        this.textMessage.y = 0;
        this.tween.start();
    }
    hide() {
        // this.textMessage.text = "";
        //this.alpha = 1;
        this.visible = false;
    }
}